// /v2/bundles katalogları için ortak önbellek ve yardımcılar.
//
// `/v2/bundles` tekil bir bundle ucu SUNMAZ — yalnızca filtrelenebilir liste
// vardır (src/FRONTEND_INTEGRATION.md §4). Bu yüzden hem sekme hem de detay
// sayfası aynı listeden beslenir; liste aile (family) başına bir kez çekilip
// paylaşılır. Bugün iki aile var: `unlimited` ve `voice`.

import i18n from '../../i18n';
import { getBundles } from './homeApi';

const langOf = (lng) => (lng || 'tr').split('-')[0];

/**
 * Bir ürün ailesi için dil-duyarlı, tek-uçuşlu (single-flight) katalog önbelleği.
 * Accept-Language yanıttaki ülke adlarını (nameSelected) etkilediği için dil
 * değişince önbellek tazelenir.
 */
export const createBundleCatalog = (family) => {
  let cache = { lang: null, promise: null };

  const load = () => {
    const lang = langOf(i18n.language);
    if (cache.lang !== lang || !cache.promise) {
      const promise = getBundles({ family }).catch((error) => {
        // Başarısız isteği önbellekte bırakma: kullanıcı "tekrar dene" dediğinde
        // aynı hatayı sonsuza dek geri vermesin.
        if (cache.promise === promise) cache = { lang: null, promise: null };
        throw error;
      });
      cache = { lang, promise };
    }
    return cache.promise;
  };

  const reset = () => {
    cache = { lang: null, promise: null };
  };

  return { load, reset };
};

// Liste yalnızca id ile aranabilir; route parametresi string gelir.
export const findBundle = (bundles, bundleId) =>
  (bundles || []).find((b) => String(b.id) === String(bundleId)) || null;

// sortOrder listeleme sırasının tek kaynağıdır — veri miktarına göre sıralama
// yapılmaz (sınırsız planlarda veri eşittir, ses paketlerinde sıra sağlayıcıdan
// gelir).
export const sortedPlans = (bundle) =>
  [...(bundle?.plans || [])].sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0));

// `priceId` yoksa plan henüz fiyatlanmamıştır ve PayPal siparişi açılamaz (§6).
export const isSellable = (plan) => Boolean(plan?.priceId);
